import { Injectable } from '@angular/core';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiDialogsProgressComponent } from '@fi-shared/fi-dialogs-generic/progress/progress.component';
import { AppTextService } from '@fi-shared/app-text';
import {
    IFiDialogProgressMessage,
    IFiDialogProgressOptions,
    IFiDialogProgressResult,
} from '@fi-shared/fi-dialogs-generic/fi-dialogs-generic';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class FiDialogsGenericService {
    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    progress(headerText: string): IFiDialogProgressResult {
        const data: IFiDialogProgressOptions = {
            messagePipe$: new ReplaySubject<IFiDialogProgressMessage>(),
        };

        const dialogRef = this.fiDialogsService.custom({
            headerText: headerText,
            yesButtonText: this.appTextService.get('common.close'),
            isNoButtonHidden: true,
            contentComponentRef: FiDialogsProgressComponent,
            contentComponentData: data,
            config: {
                disableClose: true,
            },
        });

        return {
            //dialogRef: dialogRef,
            nextMessage: (item) => {
                data.messagePipe$.next(item);
            },
            complete: () => {
                data.messagePipe$.complete();
            },
        };
    }
}
